<template>
  <div>
  <div class="container">
        <div class="row">
            
            <div class="col-lg-6 col-md-12 col-sm-24">
               <img :src="payImgUrl">
            </div>
            <div class="col-lg-12 col-md-12 col-sm-24">
              <h2>Betaalstatus</h2><br>
               <h1>{{paymentStatInfo}}</h1>
               <router-link to="/"><br><button class="check-btn sqr-btn" v-if="statusPayment === 2">Start / Maak nieuwe reservatie</button></router-link>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-24">
               <div v-if="flgShowRetryPayment"><button class="check-btn sqr-btn" @click="retryPament()">Probeer opnieuw</button></div>
            </div>
           
            <div class="col-12" style="height:40px;">
            </div>
            <div class="row"><div class="col-24">&nbsp;</div></div>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import myHttpApi from "../api/myhttpapi";
  import {
    SPINNER_SHOW,
    SPINNER_HIDE,
    CLEAR_CART
  } from '../store/mutation-types'

  export default {
    name: 'paymentstatus',
    data () {
      return {
        paymentStatInfo : '',
        statusPayment :0,
        counter : 0,
        flgShowRetryPayment : false,
        payImgUrl : '/static/img/payments/Payment-wait-120.png',
        tmr : undefined,
        id : this.$route.params['id']
      }
    },
    components: {

    },
    mounted () {
        this.statusPayment = 0;
        this.paymentStatInfo = "Betaling controleren";
        this.tmr = setInterval(this.checkStatusNow, 1000)
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
       retryPament() {

         this.flgShowRetryPayment = false;

         const token = {Search : this.id}
         myHttpApi.post( 'Basket/StartPayment', token)
              .then(response => {
                 var result = response.data;
                 
                 this.$store.commit(SPINNER_HIDE);
                 this.statusPayment =  result.ResultCode;
                 if (result.ResultCode == 200)
                 {
                    document.location = result.ErrorMsg;
                 }
                 if (result.ResultCode == 2) {
                    this.paymentStatInfo = "Betaling uitgevoerd!"
                    this.payImgUrl = '/static/img/payments/Payment-ok-120.png'
                 }
              }
          )
       },
       verifyPayment (keyPayment) {
        
        clearInterval(this.tmr)
        this.flgShowRetryPayment = false;
        const token = {Search : keyPayment}

        myHttpApi.post( 'Basket/VerifyPayment', token)
              .then(response => {
                 var result = response.data;
                 this.statusPayment =  result.ResultCode;
                 if (result.ResultCode == 1)
                 {
                    this.paymentStatInfo = "Bezig..."
                    this.payImgUrl = '/static/img/payments/Payment-wait-120.png'
                    this.tmr = setInterval(this.checkStatusNow, 1000)
                 }
                 if (result.ResultCode == 2)
                 {
                    clearInterval(this.tmr)
                    this.paymentStatInfo = "Betaling uitgevoerd!"
                    this.payImgUrl = '/static/img/payments/Payment-ok-120.png'
                 }
                 if (result.ResultCode == 3)
                 {
                    this.paymentStatInfo = "Betaling mislukt"
                    this.payImgUrl = '/static/img/payments/Payment-failed-120.png'
                    clearInterval(this.tmr)
                    this.flgShowRetryPayment = true;
                 }
                 if (result.ResultCode == 4)
                 {
                    this.paymentStatInfo = "Betaling  geannuleerd"
                    this.payImgUrl = '/static/img/payments/Payment-failed-120.png'
                    clearInterval(this.tmr)
                    this.flgShowRetryPayment = true;
                 }
                 if (result.ResultCode == 5)
                 {
                    this.paymentStatInfo = "Betaling verlopen"
                    this.payImgUrl = '/static/img/payments/Payment-failed-120.png'
                    clearInterval(this.tmr)
                    this.flgShowRetryPayment = true;
                 }

                 if (result.ResultCode == 999)
                 {
                     this.counter = 10;
                     clearInterval(this.tmr)
                     this.paymentStatInfo = "Fout bij ophalen"
                     this.payImgUrl = '/static/img/payments/Payment-failed-120.png'
                     this.flgShowRetryPayment = true;
                 }
                 console.log (this.statusPayment);
              }
          )
       },

       checkStatusNow () {
        
        this.counter += 1
        this.paymentStatInfo = "wachten.. " + this.counter
        if (this.counter % 2 == 1) this.verifyPayment (this.id)
        if (this.counter >= 15)
        {
            clearInterval(this.tmr)
            this.paymentStatInfo = "Fout bij ophalen"
            this.flgShowRetryPayment = true;
        }


        }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
  @media (max-width: 800px) {
      .hidesmall {
        display: none;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/PaymentStatus.vue